<div [ngSwitch]="view"
#scrollContainer
class="scroll-container"
[ngClass]="{'day-container': view === 'day',
 'allday-collapsed': !allDayEventsExpanded,
 'allday-expanded': allDayEventsExpanded,
 'ios-cal': isIos
}"
[style.--sticky-top]="stickyTopValue"
>
   <div *ngSwitchCase="'month'"
    (touchstart)="onDayMonthTouchStart($event)"
    (touchend)="onDayMonthTouchEnd($event)">
    <mwl-calendar-month-view
     [viewDate]="currentDateDisplayed"
     [events]="events"
     [locale]="currentLocale"
     [headerTemplate]="customMonthHeaderTemplate"
     [cellTemplate]="customMonthCellTemplate"
     (viewDateChange)="onViewDateChange($event)"
    />
  </div>

  <div *ngSwitchCase="'week'" class="relative">
    <mwl-calendar-week-view
    *ngIf="!isMobile"
    [viewDate]="currentDateDisplayed"
    [events]="events"
    [locale]="currentLocale"
    [eventTemplate]="weekEventTemplate"
    [headerTemplate]="customWeekHeader"
    [allDayEventsLabelTemplate]="allDayEventsLabelTemplate"
    (beforeViewRender)="onBeforeWeekViewRender($event)"
    />
   <!-- Vista Week personalizada para mobile (3 días) -->
   <div *ngIf="isMobile" class="flex justify-between items-center sticky top-[30px] z-5 px-2">
     <button
       class="nav-button"
       (click)="previousThreeDays()"
       aria-label="Retroceder 3 días">
       <ion-icon name="chevron-back-outline"></ion-icon>
     </button>
     <button
        class="nav-button"
        (click)="nextThreeDays()"
        aria-label="Avanzar 3 días">
        <ion-icon name="chevron-forward-outline"></ion-icon>
     </button>
   </div>

    <div *ngIf="isMobile" class="-mt-6"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)">
      <mwl-calendar-week-view
        [viewDate]="currentDateDisplayed"
        [events]="events"
        [locale]="currentLocale"
        [eventTemplate]="weekEventTemplate"
        [headerTemplate]="customWeekHeader"
        [allDayEventsLabelTemplate]="allDayEventsLabelTemplate"
        [daysInWeek]="3"
        (beforeViewRender)="onBeforeWeekViewRender($event)">
      </mwl-calendar-week-view>
    </div>
  </div>

  <div *ngSwitchCase="'day'"
    (touchstart)="onDayMonthTouchStart($event)"
    (touchend)="onDayMonthTouchEnd($event)">
    <mwl-calendar-day-view
    [viewDate]="currentDateDisplayed"
    [events]="events"
    [locale]="currentLocale"
    [eventTemplate]="dayEventTemplate"
    [allDayEventsLabelTemplate]="allDayEventsLabelTemplate"
    />
  </div>
</div>

<ng-template #dayEventTemplate
  let-weekEvent="weekEvent"
  let-eventClicked="eventClicked"
 >
    <!-- CONTENEDOR PARA EVENTOS ALL-DAY (Barra superior) -->
    <div *ngIf="weekEvent.event.allDay"
    (click)="calendarService.onEventoClick({ event: weekEvent.event })"
    [style.background]="weekEvent.event.color?.primary"
    class="text-xs md:text-base text-white text-center leading-3 font-bold px-2 py-2 rounded-default flex justify-center items-center overflow-hidden"
    >
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'checklist'" class="mdi mdi-order-bool-ascending-variant text-white leading-3"></mat-icon>
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'benefit'" class="mdi mdi-gift text-white leading-3"></mat-icon>
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'live_session' || (weekEvent.event.custom?.type?.code === 'topic' && !weekEvent.event?.custom?.address)" class="mdi mdi-video text-white leading-3"></mat-icon>
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'course'" class="mdi mdi-book-open-page-variant-outline text-white leading-3"></mat-icon>
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address" class="mdi mdi-human-male-board-poll text-white leading-3"></mat-icon>

      <strong class="overflow-text-cover-1 ml-2">
        {{ weekEvent.event?.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address && weekEvent.event?.custom?.subtitle ? weekEvent.event?.custom?.subtitle : weekEvent.event.title }}
      </strong>
    </div>
     <!-- CONTENEDOR PARA EVENTOS NORMALES-->
    <ng-container *ngIf="!weekEvent.event.allDay">
       <!-- EVENTOS CORTOS -->
      <ng-container *ngIf="(!isMobile && !(weekEvent.event.start | hasLongDuration: weekEvent.event.end : 1));else defaultDayEventTemplate">
        <div (click)="calendarService.onEventoClick({ event: weekEvent.event })"
        [style.background]="weekEvent.event.color?.primary"
        class="grid grid-cols-[auto_1fr_auto] gap-4 h-full px-1 items-center text-white rounded-default overflow-hidden" >
          <span  class="font-bold  text-xxs leading-3 flex items-start gap-1">
            <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'checklist'" class="mdi mdi-order-bool-ascending-variant text-white leading-3"></mat-icon>
            <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'benefit'" class="mdi mdi-gift text-white leading-3"></mat-icon>
            <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'live_session' || (weekEvent.event.custom?.type?.code === 'topic' && !weekEvent.event?.custom?.address)" class="mdi mdi-video text-white leading-3"></mat-icon>
            <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'course'" class="mdi mdi-book-open-page-variant-outline text-white leading-3"></mat-icon>
            <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address" class="mdi mdi-human-male-board-poll text-white leading-3"></mat-icon>

            {{weekEvent.event.custom?.type?.label}}
          </span>
          <span class="text-sm leading-3 text-ellipsis overflow-hidden text-nowrap w-full font-bold text-white">
            {{ weekEvent.event?.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address && weekEvent.event?.custom?.subtitle ? weekEvent.event?.custom?.subtitle : weekEvent.event.title }}
          </span>
          <div class="flex items-center gap-3 text-xxs leading-3">
            <span class="text-white">{{ weekEvent.event.start | date:'HH:mm' }} - {{ weekEvent.event.end | date:'HH:mm' }}</span>
            <span  class="flex items-center gap-1">
              Detalles
              <mat-icon class="mdi mdi-chevron-right text-lg leading-5 w-4 h-4"></mat-icon>
            </span>
          </div>
        </div>
      </ng-container>
       <!-- EVENTOS largos -->
      <ng-template #defaultDayEventTemplate>
        <div (click)="calendarService.onEventoClick({ event: weekEvent.event })"
         [style.background]="weekEvent.event.color?.primary"
         class="flex flex-col gap-2 h-full py-1.5 px-1 text-white rounded-default overflow-hidden border-1 border-solid border-[#ffffff91]"
        >
        <!-- [style.border]="'1px solid ' + weekEvent.event.color?.primary" -->
          <div  class="flex justify-between items-center text-xxs md:text-xs leading-3">
            <span class="font-bold flex items-center gap-1">
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'checklist'" class="mdi mdi-order-bool-ascending-variant text-white leading-3"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'benefit'" class="mdi mdi-gift text-white leading-3"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'live_session' || (weekEvent.event.custom?.type?.code === 'topic' && !weekEvent.event?.custom?.address)" class="mdi mdi-video text-white leading-3"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'course'" class="mdi mdi-book-open-page-variant-outline text-white leading-3"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address" class="mdi mdi-human-male-board-poll text-white leading-3"></mat-icon>

              {{weekEvent.event.custom?.type?.label}}
            </span>
            <span *ngIf="weekEvent.event.start | hasLongDuration: weekEvent.event.end : 1" class="flex items-center">
              Detalles
              <mat-icon class="mdi mdi-chevron-right text-lg leading-5"></mat-icon>
            </span>
          </div>

          <div class="flex justify-between items-center  font-bold text-white">
            <span [ngClass]="(weekEvent.event.start | hasLongDuration: weekEvent.event.end : 1) ? 'text-base md:text-lg leading-6 text-wrap' : 'text-sm md:text-base leading-4 text-ellipsis overflow-hidden text-nowrap w-[65vw]'">
              {{ weekEvent.event?.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address && weekEvent.event?.custom?.subtitle ? weekEvent.event?.custom?.subtitle : weekEvent.event.title }}
            </span>
            <mat-icon *ngIf="!(weekEvent.event.start | hasLongDuration: weekEvent.event.end : 1)" class="mdi mdi-chevron-right text-lg leading-5"></mat-icon>
          </div>

          <div class="flex justify-between items-center text-white text-xxs md:text-xs leading-3 italic">
            <span>{{ weekEvent.event.start | date:'HH:mm' }} - {{ weekEvent.event.end | date:'HH:mm' }}</span>
          </div>
        </div>
      </ng-template>
    </ng-container>

</ng-template>

<ng-template #weekEventTemplate
  let-weekEvent="weekEvent"
  let-eventClicked="eventClicked"
 >
    <!-- CONTENEDOR PARA EVENTOS ALL-DAY (Barra superior) -->
    <div *ngIf="weekEvent.event.allDay"
    (click)="calendarService.onEventoClick({ event: weekEvent.event })"
    [style.background]="weekEvent.event.color?.primary"
    class="text-xs md:text-base text-white text-center leading-3 font-medium px-2 py-2 rounded-default flex justify-center items-center overflow-hidden gap-2"
    >
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'checklist'" class="mdi mdi-order-bool-ascending-variant text-white leading-3"></mat-icon>
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'benefit'" class="mdi mdi-gift text-white leading-3"></mat-icon>
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'live_session' || (weekEvent.event.custom?.type?.code === 'topic' && !weekEvent.event?.custom?.address)" class="mdi mdi-video text-white leading-3"></mat-icon>
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'course'" class="mdi mdi-book-open-page-variant-outline text-white leading-3"></mat-icon>
      <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address" class="mdi mdi-human-male-board-poll text-white leading-3"></mat-icon>

      <strong class="overflow-text-cover-1">
        {{ weekEvent.event?.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address && weekEvent.event?.custom?.subtitle ? weekEvent.event?.custom?.subtitle : weekEvent.event.title }}
      </strong>
    </div>
  <!-- CONTENEDOR PARA EVENTOS NORMALES-->
    <ng-container *ngIf="!weekEvent.event.allDay">
      <!-- EVENTOS CORTOS -->
      <ng-container *ngIf="(!isMobile && !(weekEvent.event.start | hasLongDuration: weekEvent.event.end : 1));else defaultDayEventTemplate">
        <div (click)="calendarService.onEventoClick({ event: weekEvent.event })"
        [style.background]="weekEvent.event.color?.primary"
        class="corto grid grid-cols-[1fr_auto] gap-1 h-full px-1 items-center text-white rounded-default overflow-hidden"
        >
          <div class="flex-col w-full">
            <div class="flex items-start gap-1">
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'checklist'" class="mdi mdi-order-bool-ascending-variant text-white leading-3 mt-[2px]"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'benefit'" class="mdi mdi-gift text-white leading-3 mt-[2px]"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'live_session' || (weekEvent.event.custom?.type?.code === 'topic' && !weekEvent.event?.custom?.address)" class="mdi mdi-video text-white leading-3 mt-[2px]"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'course'" class="mdi mdi-book-open-page-variant-outline text-white leading-3 mt-[2px]"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address" class="mdi mdi-human-male-board-poll text-white leading-3 mt-[2px]"></mat-icon>
              <p class="overflow-text-cover-2 text-sm leading-5 text-ellipsis overflow-hidden  w-full font-bold text-white text-wrap">
                {{ weekEvent.event?.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address && weekEvent.event?.custom?.subtitle ? weekEvent.event?.custom?.subtitle : weekEvent.event.title }}
              </p>

            </div>
            <span class="text-white text-xs">
              {{ weekEvent.event.start | date:'HH:mm' }} - {{ weekEvent.event.end | date:'HH:mm' }}
            </span>
          </div>
          <mat-icon class="mdi mdi-chevron-right text-lg leading-5 w-4 h-4"></mat-icon>
        </div>
      </ng-container>
      <!-- EVENTOS LARGOS -->
      <ng-template #defaultDayEventTemplate>
        <div (click)="calendarService.onEventoClick({ event: weekEvent.event })"
        [style.background]="weekEvent.event.color?.primary"
        class="flex flex-col gap-2 h-full py-1.5 px-1 text-white rounded-default overflow-hidden border-1 border-solid border-[#ffffff86]"
        >
        <!-- [style.border]="'1px solid ' + weekEvent.event.color?.primary" -->
          <div class="flex justify-between items-center text-xs text-white leading-3">
            <span class="font-bold flex items-center gap-1">
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'checklist'" class="mdi mdi-order-bool-ascending-variant text-white leading-3"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'benefit'" class="mdi mdi-gift text-white leading-3"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'live_session' || (weekEvent.event.custom?.type?.code === 'topic' && !weekEvent.event?.custom?.address)" class="mdi mdi-video text-white leading-3"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'course'" class="mdi mdi-book-open-page-variant-outline text-white leading-3"></mat-icon>
              <mat-icon *ngIf="weekEvent.event.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address" class="mdi mdi-human-male-board-poll text-white leading-3"></mat-icon>

              {{weekEvent.event.custom?.type?.label}}
            </span>
          </div>

          <div class="flex justify-between items-center  font-bold text-white ">
            <div class="flex flex-col  gap-1">
              <span class="text-xs md:text-sm leading-[13px]"
              [ngClass]="(weekEvent.event.start | hasLongDuration: weekEvent.event.end : 1) ? 'text-wrap' : 'text-ellipsis overflow-hidden text-nowrap w-[65vw]'">
                {{ weekEvent.event?.custom?.type?.code === 'topic' && weekEvent.event?.custom?.address && weekEvent.event?.custom?.subtitle ? weekEvent.event?.custom?.subtitle : weekEvent.event.title }}
              </span>
            </div>

            <mat-icon *ngIf="!(weekEvent.event.start | hasLongDuration: weekEvent.event.end : 1)" class="mdi mdi-chevron-right text-lg leading-5"></mat-icon>
          </div>

          <div class="flex justify-between items-center text-white text-xxs md:text-xs leading-3 italic">
            <span>{{ weekEvent.event.start | date:'HH:mm' }} - {{ weekEvent.event.end | date:'HH:mm' }}</span>
          </div>
        </div>
      </ng-template>
    </ng-container>

</ng-template>


<!-- "nro de dia" en cabecera de calendario  -->
<ng-template #customWeekHeader
    let-days="days"
  let-locale="locale"
  let-trackByWeekDayHeaderDate="trackByWeekDayHeaderDate"
  >
  <div class="cal-day-headers" role="row">
    <div
      class="cal-header"
      *ngFor="let day of days; trackBy: trackByWeekDayHeaderDate"
      [class.cal-past]="day.isPast"
      [class.cal-today]="day.isToday"
      [class.cal-future]="day.isFuture"
      [class.cal-weekend]="day.isWeekend"
      [ngClass]="day.cssClass"
      (click)="onDayHeaderClick(day)"
      role="columnheader">

      <div class="custom-day-header">
        <div class="dia-nombre text-xxs">
          {{ obtenerNombreDia(day.date) }}
        </div>
        <div class="dia-numero text-3xl" [class.today]="day.isToday" [ngClass]="day.isToday ? 'today' : 'not-today'">
          {{ day.date | date:'d' }}
        </div>
        <!-- <div class="mes-nombre">
          {{ obtenerNombreMes(day.date) }}
        </div> -->
      </div>
    </div>
  </div>
</ng-template>

<ng-template #customMonthCellTemplate
let-day="day"
let-locale="locale"
>
  <div class="cal-cell-top flex justify-center mb-1">
    <!-- <span class="cal-day-number text-xs"
    [class.cal-today]="day.isToday"
    (click)="verMasEventos(day)"
    >
      <ng-container *ngIf="day.date.getDate() === 1; else onlyDayNumber">
        {{ day.date | date:"d 'de' MMM":undefined:currentLocale }}
      </ng-container>
      <ng-template #onlyDayNumber>{{ day.date | date:'d' }}</ng-template>
    </span> -->

    <!-- primer día del mes -->
    <button *ngIf="day.date.getDate() === 1"
    class=" flex justify-center items-center p-1 gap-1 text-xs"
    (click)="verMasEventos(day)"
    >
      <span class="cal-day-number custom-number text-xs"  [class.cal-today]="day.isToday">
        {{ day.date | date:'d' }}
      </span>
      <span class="text-xs cal-day-number hidden md:flex">
        {{ day.date | date:"'de' MMM":undefined:currentLocale }}
      </span>
    </button>

    <button *ngIf="day.date.getDate() !== 1"
    class=" flex justify-center items-center p-1 gap-1 text-xs"
    (click)="verMasEventos(day)"
    >
      <span class="cal-day-number custom-number  text-xs"  [class.cal-today]="day.isToday">
        {{ day.date | date:'d' }}
      </span>
    </button>
  </div>

  <!-- Lista de eventos -->
  <div class="eventos-lista">
    <ng-container *ngFor="let evento of getSortedEventsForMonth(day.events); index as i">
      <div
      [style.background-color]="evento?.allDay ? evento?.color?.primary : 'transparent'"
      class="mb-1 rounded-default cursor-pointer"
      [ngClass]="{'pl-1': evento?.allDay
      }"
      (click)="calendarService.onEventoClick({ event: evento })"
      >
        <div class="flex items-center gap-1 rounded-default py-[2px]"
        [ngClass]="{
          'hover:bg-primary_ultra_light_variant': !evento?.allDay,
        }">
          <ion-icon *ngIf="!evento?.allDay"
          name="ellipse-outline"
          class="w-2 h-2 min-w-[8px] min-h-[8px] self-start pt-1"
          [style.color]="evento?.color?.primary">
          </ion-icon>
          <p class="text-xxs flex gap-1 items-center overflow-text-cover-2 " [ngClass]="{'text-white': evento?.allDay}">
            <span *ngIf="!evento?.allDay" class="text-[8px]">{{ evento?.start | date:'HH:mm' }} - {{ evento?.end | date:'HH:mm' }}</span>
            <span class="" [ngClass]=" evento?.allDay ? 'font-normal' : 'pl-1 font-semibold'">{{evento?.custom?.type?.code === 'topic' && evento?.custom?.address && evento?.custom?.subtitle ? evento?.custom?.subtitle : evento?.title }}</span>
          </p>
        </div>
      </div>
    </ng-container>

    <!-- Indicador de más eventos si no caben -->
    <button *ngIf="day.events.length > 3"
    class="mas-eventos text-primary"
    (click)="verMasEventos(day)"
    >
      +{{ day.events.length - 3 }} más
    </button>
  </div>
</ng-template>

<ng-template #allDayEventsLabelTemplate>
  <div class="all-day-events-height-reference h-full w-full flex items-center  gap-2"
  [ngClass]="{'justify-center': !showAllDayToggle}">
    <strong [ngClass]="{'pl-[6px] md:pl-2': showAllDayToggle}">Eventos</strong>
    <!-- <div *ngIf="isLoadingEvents" class="skeleton-loader flex gap-1">
      <div class="skeleton-bar"></div>
      <div class="skeleton-bar"></div>
      <div class="skeleton-bar"></div>
    </div> -->
    <button *ngIf="showAllDayToggle" class="allday-toggle-btn " (click)="toggleAllDayEvents()" [attr.aria-label]="allDayEventsExpanded ? 'Colapsar eventos' : 'Expandir eventos'">
      <ion-icon [name]="allDayEventsExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
    </button>
  </div>
</ng-template>

<ng-template #customMonthHeaderTemplate let-days="days" let-locale="locale">
  <div class="cal-cell-row cal-header" role="row">
    <div
      class="cal-cell"
      *ngFor="let day of days"
      [class.cal-past]="day.isPast"
      [class.cal-today]="day.isToday"
      [class.cal-future]="day.isFuture"
      [class.cal-weekend]="day.isWeekend"
      role="columnheader">
      <span class="month-day-full">{{ obtenerNombreDiaCompleto(day.date) }}</span>
      <span class="month-day-short">{{ obtenerNombreDiaCorto(day.date) }}</span>
    </div>
  </div>
</ng-template>

<!-- <ng-template #customMarkerTemplate let-columnDate="columnDate">
  <div class="custom-marker-container">
    <div class="marker-circle"></div>
    <div class="marker-line"></div>
    <div class="marker-time">
      {{ columnDate | date:'HH:mm' }}
    </div>
  </div>
</ng-template> -->


